const medicalTest = {
  RT_PCR: "RT_PCR",
  ANTIBODY: "ANTIBODY",
};

export default Object.freeze(medicalTest);
